// 插件路由
const routes = [
	{ 
        path: '/debtconsume', 
        component: () => import(/* webpackChunkName: "debt" */ '~/addon/debtconsume/pages/debt.vue') 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/debtconsume/router/index.js